"use client";

import CustomImage from "@/components/CustomImage";
import { SingleItemType } from "..";
import { Swiper, SwiperSlide } from "swiper/react";
import Button from "@/components/Button";
import Text from "@/components/Text";
import { useState } from "react";
import { Swiper as SwiperCore } from "swiper";
import GridCarouselButtons from "./GridCarouselButtons";

type GridCarouselProps = {
  item: SingleItemType;
};

const GridCarousel = ({ item }: GridCarouselProps) => {
  const [isNavigationVisible, setIsNavigationVisible] = useState(true);
  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);

  const handleSlideChange = (swiper: SwiperCore) => {
    setDisablePrev(swiper.isBeginning);
    setDisableNext(swiper.isEnd);
  };
  const checkSlidesCount = (swiper: SwiperCore) => {
    const slidesPerView = swiper.params.slidesPerView;
    const enoughSlides = swiper.slides.length > Number(slidesPerView);
    setIsNavigationVisible(enoughSlides);
  };
  return (
    <div className="grid-images-with-carousel__item">
      <Swiper
        onInit={(swiper) => checkSlidesCount(swiper)}
        onResize={(swiper) => checkSlidesCount(swiper)}
        onSlideChange={(swiper: SwiperCore) => handleSlideChange(swiper)}
        allowTouchMove={false}
      >
        {item.carousel.map((itemCarousel, index) => (
          <SwiperSlide key={`${itemCarousel.text}-${index}`}>
            {itemCarousel.image ? (
              <CustomImage
                alt={itemCarousel.image.alt}
                src={itemCarousel.image.src.desktop}
                srcTablet={itemCarousel.image.src.tablet}
                srcMobile={itemCarousel.image.src.mobile}
                className="image--bg"
              />
            ) : null}
            {itemCarousel.tag ? (
              <div className="grid-images-with-carousel__item-tag">
                <Text
                  element="p"
                  elementStyle="body-secondary"
                  className="weight-600"
                >
                  {itemCarousel.tag}
                </Text>
              </div>
            ) : null}
            <div className="grid-images-with-carousel__item-content">
              {!!itemCarousel.button ? (
                <Button
                  type="primary"
                  mode="dark"
                  isTargetBlank
                  isLink
                  href={itemCarousel.button.link}
                >
                  {itemCarousel.button.text}
                </Button>
              ) : null}
              <Text
                element="h3"
                elementStyle="subtitle"
                fontFamily="noto-serif"
                className="text-center grid-images-with-carousel__item-title"
              >
                {itemCarousel.title}
              </Text>
              {itemCarousel.text ? (
                <Text
                  element="p"
                  elementStyle="subtitle-secondary"
                  className="text-center grid-images-with-carousel__item-text"
                >
                  {itemCarousel.text}
                </Text>
              ) : null}
              {itemCarousel.additionalText ? (
                <Text
                  element="p"
                  elementStyle="body"
                  className="weight-700 text-center grid-images-with-carousel__item-additional-text"
                >
                  {itemCarousel.additionalText}
                </Text>
              ) : null}
            </div>
          </SwiperSlide>
        ))}
        {isNavigationVisible ? (
          <GridCarouselButtons
            disableNext={disableNext}
            disablePrev={disablePrev}
          />
        ) : null}
      </Swiper>
    </div>
  );
};

export default GridCarousel;
